import React from 'react';
import { css, SelectConfig, IconConfig, tokens, media } from '@sail/ui';
// @ts-expect-error: Type 'ForwardRefExoticComponent<Pick<SVGProps<SVGSVGElement> is not assignable to type 'SvgType'.
const helmChevronDownSvg = React.forwardRef(function addSvgInner(props, ref) {
    return /* #__PURE__ */ React.createElement('svg', {
        ...props,
        ref
    }, /* #__PURE__ */ React.createElement('path', {
        d: 'M9 1L5 5 1 1',
        stroke: '#4F566B',
        fill: 'none',
        strokeWidth: '1.8'
    }));
});
helmChevronDownSvg.defaultProps = {
    width: '10',
    viewBox: '0 0 10 7',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
};
const helmChevronDown = {
    category: 'icon',
    colorable: true,
    name: 'helmChevonDown',
    svg: helmChevronDownSvg
};
export const selectCustomization = SelectConfig.customize({
    variants: {
        size: {
            small: {
                subviews: {
                    input: {
                        css: {
                            paddingLeft: '8px',
                            paddingY: '4px'
                        }
                    }
                }
            },
            medium: {
                subviews: {
                    input: {
                        css: {
                            paddingLeft: '12px',
                            paddingY: '8px'
                        }
                    }
                }
            },
            large: {
                subviews: {
                    input: {
                        css: {
                            paddingLeft: '14px',
                            paddingY: '14px'
                        }
                    }
                }
            }
        }
    },
    uses: [
        css({
            gapX: 'large',
            gapY: 'small',
            gridTemplateColumns: '1fr',
            [media.up(tokens.viewport.small)]: {
                gapY: '0',
                gridTemplateColumns: '160px 1fr',
                gridTemplateRows: 'repeat(auto-fit)'
            }
        })
    ],
    subviews: {
        inputs: {
            uses: [
                css({
                    gridRow: 'auto',
                    [media.up(tokens.viewport.small)]: {
                        gridRow: '1',
                        gridColumn: '2'
                    }
                }),
                IconConfig.customize({
                    uses: [
                        css({
                            maxWidth: 'space.125',
                            position: 'relative',
                            right: 'xsmall'
                        })
                    ]
                })
            ]
        },
        input: {
            uses: [
                css({
                    fontWeight: 'normal',
                    ':hover:not(:disabled)': {
                        backgroundColor: 'form'
                    },
                    ':focus:not(:disabled)': {
                        backgroundColor: 'form'
                    },
                    '[aria-invalid="false"]': {
                        boxShadow: `none`
                    },
                    '[aria-invalid="true"]': {
                        keyline: `${tokens.color.border.form.error}`
                    },
                    '[aria-invalid="true"]:hover': {
                        keyline: `${tokens.color.border.form.error}`
                    }
                })
            ]
        },
        description: {
            uses: [
                css({
                    [media.up(tokens.viewport.small)]: {
                        gridColumn: '1',
                        alignSelf: 'start'
                    }
                })
            ]
        },
        error: {
            uses: [
                css({
                    column: '2/1',
                    [media.up(tokens.viewport.small)]: {
                        marginTop: `${tokens.space.small}`,
                        gridArea: '2/2'
                    }
                })
            ]
        }
    },
    defaults: {
        icon: helmChevronDown,
        size: 'medium'
    }
});

//# sourceMappingURL=select.js.map